<div class="content-blk">
  <div class="container dv-stradmn-accninfo">
    <h5 class="page-title">
      Update Profile
    </h5>
    <small *ngIf="forceChangePassword" class="blink_me text-danger">*Stoked On Printing is simplifying the process of
      login on it's all platform so you won’t have to create separate accounts. In order to fulfill this it is requested
      to change your password, thank you for your cooperation.</small>
    <form [formGroup]="editStoreAdminProfileForm" (submit)="UpdateStoreAdminProfile(editStoreAdminProfileForm)"
      autocomplete="off">
      <!--<div id="paypal-button" style="display:none;"></div>-->
      <div class="store-set-blk vw-pro-ux">
        <!--h4 class="str-st-hd">Store Status</h4-->
        <div class="store-set-ui">
          <div class="row">
            <!-- CONTACT IONFORMATION-->
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  Personal Information
                </mat-card-title>
                <mat-card-content>
                  <div class="example-form">
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>First Name</mat-label>
                          <input matInput formControlName="FirstName">
                          <mat-error *ngIf="f.FirstName.touched && f.FirstName.invalid && f.FirstName.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.FirstName.valid && (!f.FirstName.hasError('pattern') && f.FirstName.touched && f.FirstName.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.FirstName.valid && (f.FirstName.hasError('pattern') && f.FirstName.dirty)">
                            Should contain only letters
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Last Name</mat-label>
                          <input matInput formControlName="LastName">
                          <mat-error *ngIf="f.LastName.touched && f.LastName.invalid && f.LastName.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.LastName.valid && (!f.LastName.hasError('pattern') && f.LastName.touched && f.LastName.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.LastName.valid && (f.LastName.hasError('pattern') && f.LastName.dirty)">
                            Should contain only letters
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Email</mat-label>
                          <input matInput formControlName="Email" readonly>
                          <mat-error *ngIf="f.Email.touched && f.Email.invalid && f.Email.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.Email.valid && (!f.Email.hasError('pattern') && f.Email.touched && f.Email.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.Email.valid && (f.Email.hasError('pattern') && f.Email.dirty)">
                            Invalid Email Address
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Phone Number</mat-label>
                          <input matInput maxlength="10" formControlName="PhoneNumber">
                          <mat-error *ngIf="!f.PhoneNumber.valid && f.PhoneNumber.touched">
                             <span *ngIf="(f.PhoneNumber.hasError('pattern') || f.PhoneNumber.hasError('minlength') || f.PhoneNumber.hasError('maxlength')) && (f.PhoneNumber.pristine || f.PhoneNumber.dirty)">
                                Should contain only 10-digit numbers
                              </span>
                              <span *ngIf="(!f.PhoneNumber.hasError('pattern') && !f.PhoneNumber.hasError('minlength') && !f.PhoneNumber.hasError('maxlength')) && (f.PhoneNumber.pristine || f.PhoneNumber.dirty)">
                                <strong>Required</strong>
                              </span>
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-sm-6">
                          <mat-select formControlName="CountryId" placeholder="Country" (selectionChange)="getStatesByCountry($event.value)">
                            <mat-option *ngFor="let country of countries" [value]="country.Value">
                              {{ country.Text }}
                            </mat-option>
                          </mat-select>
                      </div>
                      <div class="col-sm-6">
                        <mat-select  placeholder="State" formControlName="StateId">
                          <mat-option *ngFor="let state of states" [value]="state.Value">
                            {{state.Text}}
                          </mat-option>
                        </mat-select>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>City</mat-label>
                          <input matInput formControlName="City">
                          <mat-error *ngIf="f.City.touched && f.City.invalid && f.City.pristine">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error
                            *ngIf="!f.City.valid && (!f.City.hasError('pattern') && f.City.touched && f.City.dirty)">
                            <strong>Required</strong>
                          </mat-error>
                          <mat-error *ngIf="!f.City.valid && (f.City.hasError('pattern') && f.City.dirty)">
                            Should contain only letters
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="col-sm-6">
                        <mat-form-field class="example-full-width">
                          <mat-label>Zipcode</mat-label>
                          <input matInput formControlName="ZipCode">
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                          <mat-label>Address</mat-label>
                          <textarea matInput formControlName="AddressLine"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <mat-form-field class="example-full-width">
                          <mat-label>Customer Account Number</mat-label>
                          <input matInput placeholder="Customer Account Number" readonly maxlength="10"
                            formControlName="CustomerAccountNumber">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <!-- STORE NAME AND DESCRIPTION-->
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  Account Information
                </mat-card-title>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-5 text-center">
                      <div>
                        <img style="border-radius:50%" class="ban-ht-wrp" id="blah"
                          [src]="imageSrc || 'assets/img/default_user_img.png'" alt="banner image" />
                      </div>
                      <input type='button' class="chng-img-spc btn btn-sm btn-info" value="Change Image"
                        (click)="openUploadImageDialog()">
                    </div>
                    <div class="col-sm-7">
                      <mat-form-field class="example-full-width">
                        <mat-label>User Name</mat-label>
                        <input matInput formControlName="UserName" readonly autocomplete="off">
                      </mat-form-field>
                      <mat-form-field class="example-full-width">
                        <mat-label>Current Password</mat-label>
                        <input type="password" matInput formControlName="CurrentPassword" autocomplete="new-password">
                        <mat-error *ngIf="f.CurrentPassword.hasError('MatchPassword') && f.CurrentPassword.touched">
                          Password is required for change password
                        </mat-error>

                      </mat-form-field>
                      <mat-form-field class="example-full-width">
                        <mat-label>New Password</mat-label>
                        <input type="password" matInput formControlName="Password">
                        <mat-error *ngIf="f.Password.touched && !f.Password.hasError('MatchPassword')">
                          <strong>Required</strong>
                        </mat-error>
                        <mat-error
                          *ngIf="!f.Password.valid && f.Password.hasError('MatchPassword') && f.Password.touched">
                          Current and new password cannot be same
                        </mat-error>

                      </mat-form-field>

                      <mat-form-field class="example-full-width">
                        <mat-label>Confirm Password</mat-label>
                        <input type="password" matInput formControlName="ConfirmPassword">
                        <mat-error
                          *ngIf="f.ConfirmPassword.valid && f.ConfirmPassword.touched && (f.ConfirmPassword.pristine || f.ConfirmPassword.dirty)">
                          <strong>Required</strong>
                        </mat-error>
                        <mat-error *ngIf="f.ConfirmPassword.hasError('MatchPassword') && f.ConfirmPassword.touched">
                          Password does not match
                        </mat-error>
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>




          <h5 class="page-title">
            Mode of Payment
          </h5>
          <div class="row">
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  Paypal Account for commission payment
                </mat-card-title>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <mat-form-field class="example-full-width">
                        <mat-label>Account Holder Name</mat-label>
                        <input matInput formControlName="PayPal_AccHolderName">
                      </mat-form-field>
                    </div>
                    <div class="col-sm-12">
                      <mat-form-field class="example-full-width">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="PayPal_EmailAddress">
                      </mat-form-field>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
            <div class="col-lg-6 mat-crd-ui">
              <mat-card>
                <mat-card-title>
                  W9 Information
                </mat-card-title>
                <mat-card-content>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-6">
                          <div id="paypal-button"></div>
                        </div>
                        <div class="col-sm-6">
                          <a *ngIf="pdfw9 != null" [href]="sanitize(pdfw9)" [download]="'user'+UserId+'w9form.pdf'"
                            target="_blank" class="storeadmin-btn">Submitted W9 PDF file</a>
                          <a *ngIf="pdfw9 == null" [routerLink]="[ '/store/W9Form']" class="storeadmin-btn">
                            Submit W9
                            Details
                          </a><br />
                        </div>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
          <a class="storeadmin-btn text-danger" (click)="fn_deleteAccount()">Deactivate Account ?</a>
          <div class="text-right sv-up-dt">
            <button class="mat-btn btn-danger" mat-raised-button cdkFocusInitial
              [disabled]="editStoreAdminProfileForm.invalid">
              Submit
            </button>
          </div>
          <br />
          <br />
        </div>
      </div>
    </form>
  </div>
</div>